export default __webpack_public_path__ + "static/media/phone.d7aa517b.svg";